import {
  BorrowerDocumentationRequired,
  DocumentationRequiredType,
  Loan,
  LoanDocumentationRequired,
  OnboardingDetailsRole,
} from '@nemuru-eng/js-api-client';

import { DocumentationCardParams } from '@/components/modules/Documentation/types/DocumentationCardParams';
import { Text } from '@/components/shared/components/Text';

export const useParticipantParamsByType = () => {
  const getParticipantCardParamsByType = ({
    currentLoan,
    documentationRequiredType,
    documentationRequired,
  }: {
    currentLoan: Loan;
    documentationRequiredType: DocumentationRequiredType;
    documentationRequired: BorrowerDocumentationRequired | LoanDocumentationRequired;
  }): DocumentationCardParams | undefined => {
    const documentationId = getDocumentationIdByDocumentationRequiredType(
      documentationRequiredType,
      documentationRequired,
    );

    if (documentationRequiredType === DocumentationRequiredType.LOAN)
      return {
        documentationRequiredType: DocumentationRequiredType.LOAN,
        iconName: 'description',
        labelText: <Text tId={'LOAN'} />,
        labelIdentifier: currentLoan?.id,
      };

    if (!documentationId) return;

    const currentParticipantDetails = currentLoan.onboardingDetails.find(
      (details) => 'borrowerId' in details && details.borrowerId === documentationId,
    );

    if (!currentParticipantDetails && documentationRequiredType === DocumentationRequiredType.BORROWER) return;

    switch (documentationRequiredType) {
      case DocumentationRequiredType.BORROWER:
        return {
          documentationRequiredType: DocumentationRequiredType.BORROWER,
          iconName: currentParticipantDetails?.role === OnboardingDetailsRole.BORROWER ? 'person' : 'group',
          labelText: <Text tId={currentParticipantDetails?.role ?? ''} />,
          labelIdentifier: `${currentParticipantDetails?.invitation.fullName.firstName} ${currentParticipantDetails?.invitation.fullName.lastName}`,
        };

      default:
        break;
    }
  };

  const getDocumentationIdByDocumentationRequiredType = (
    documentationRequiredType: DocumentationRequiredType,
    documentationRequired: BorrowerDocumentationRequired | LoanDocumentationRequired,
  ): string | undefined => {
    switch (documentationRequiredType) {
      case DocumentationRequiredType.BORROWER:
        if ('borrowerId' in documentationRequired) return documentationRequired.borrowerId;
        break;
      case DocumentationRequiredType.LOAN:
        return documentationRequired.loanId;
      default:
        break;
    }
  };

  return { getParticipantCardParamsByType };
};
